export default __webpack_public_path__ + "media/paypal-logo.d59f6ea764e6c134.png";